import axios from "axios";

export interface UpdateClaimNumberParams {
  transactionId: number;
  claimNumber: string;
}

export const updateClaimNumber = (params: UpdateClaimNumberParams) =>
  axios.patch("transactions/updateClaimNumber", params).then(({ data }) => data);
